import { filterTypes } from "../../constants/ui";

// The filter panel sits above the messages dialog. Autocomplete menus portal
// to the page at the dialog layer, so they have to be lifted above this panel
// or the list opens out of sight.
const menuAboveFilterPanel = {
  slotProps: {
    popper: {
      style: { zIndex: 1400 },
      sx: { zIndex: (theme) => theme.zIndex.modal + 3 },
    },
  },
};

export const messageConversationFilters = [
  {
    group: "Student Info",
    field: "cohort_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Cohort",
      label: "Cohort",
      multiple: true,
      ...menuAboveFilterPanel,
    },
  },
  {
    group: "Student Info",
    field: "current_team__in",
    type: filterTypes.API_AUTOCOMPLETE,
    props: {
      apiUrl: "/api/coaching/teams/autocomplete/",
      multiple: true,
      label: "Team",
      ...menuAboveFilterPanel,
    },
  },
  {
    group: "Student Info",
    field: "current_assistant_coach_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "CoachProfile",
      label: "Assistant Coach",
      multiple: true,
      defaultParams: {
        role_assignments__role__in: ["Assistant Coach"],
        is_active: true,
      },
      ...menuAboveFilterPanel,
    },
  },
  {
    group: "Student Info",
    field: "program_type__in",
    type: filterTypes.API_AUTOCOMPLETE,
    props: {
      apiUrl: "/api/messaging/student-types/",
      multiple: true,
      label: "Student Type",
      ...menuAboveFilterPanel,
    },
  },
  {
    group: "Student Info",
    field: "organization_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Organization",
      label: "Organization",
      multiple: true,
      ...menuAboveFilterPanel,
    },
  },
];
